import { formatDate } from "../../../../_src_shared/utils/functions/formatDate";
import { formatPhone } from "../../../../_src_shared/utils/functions/formatPhone";
import { formatSsn } from "../../../../_src_shared/utils/functions/formatSsn";
import { formatDollar } from "../../../../utils/numbers/formatDollar";
import { formatPercent } from "../../../../utils/numbers/formatPercent";

export const pdfBuilderGetTypeValue = (value, type) => {
  switch (type) {
    case "date":
      return formatDate(value);
    case "phone":
      return formatPhone(value);
    case "ssn":
      return formatSsn(value);
    case "dollar":
      return formatDollar(value);
    case "percent":
      return formatPercent(value);
    default:
      return value;
  }
};
